module.exports = __webpack_public_path__ + "01_cheek.f0ceb5ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer2/01_cheek.png
// module id = JzFb
// module chunks = 0